import { render, staticRenderFns } from "./CustomerSource.vue?vue&type=template&id=44bb8020&scoped=true&"
import script from "./CustomerSource.vue?vue&type=script&lang=js&"
export * from "./CustomerSource.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSource.vue?vue&type=style&index=0&id=44bb8020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bb8020",
  null
  
)

export default component.exports